import { render, staticRenderFns } from "./BusinessDocumentsView.vue?vue&type=template&id=840ecab8&lang=pug&"
import script from "./BusinessDocumentsView.vue?vue&type=script&lang=js&"
export * from "./BusinessDocumentsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports